import type { ActionsLocales } from './actions';
import type { AuthLocales } from './auth';
import type { Locales } from './locales';
import type { SystemLocales } from './system';

type InterpolationParams = Record<string, string | number>;

function createTranslations<
  T extends Locales | AuthLocales | SystemLocales | ActionsLocales,
>({ locales, lang = 'vi' }: { locales: T; lang: keyof T }) {
  return function translate(
    key: keyof T[typeof lang],
    params?: InterpolationParams
  ) {
    const value = locales[lang][key] || key;

    if (typeof value === 'string' && params) {
      return Object.entries(params).reduce((result, [paramKey, paramValue]) => {
        return result.replace(
          new RegExp(`{{${paramKey}}}`, 'g'),
          String(paramValue)
        );
      }, value);
    }

    return value;
  };
}

export default createTranslations;
